import React from 'react'
import { useOutsideClick } from 'rooks'
import { isReactNativeApp } from '@mobi/web-native-comms/web'
import { Button, Icon } from '@mobi/component-library/Common/V2'
import { Tooltip } from '@mobi/component-library/Common/V2/Tooltip'
import { FollowButtonLocation } from '../types'

export const NotificationButtonComponent: React.FC<{
  isPending: boolean
  handleNotifyClick: () => void
  isNotificationsEnabledState: boolean
  shouldShowAlertsTooltip: boolean
  setShouldShowAlertsTooltip: React.Dispatch<React.SetStateAction<boolean>>
  location: FollowButtonLocation
}> = ({
  isPending,
  handleNotifyClick,
  isNotificationsEnabledState,
  shouldShowAlertsTooltip,
  setShouldShowAlertsTooltip,
  location,
}) => {
  const alertsTooltipRef = React.useRef<HTMLButtonElement>(null)
  useOutsideClick(alertsTooltipRef, () => {
    if (shouldShowAlertsTooltip) setShouldShowAlertsTooltip(false)
  })

  const canShowAlertsTooltip =
    shouldShowAlertsTooltip && !isNotificationsEnabledState && location !== 'shared-bet-card'

  return isReactNativeApp || process.env.NODE_ENV === 'development' ? (
    <Button
      size='sm'
      isIconOnlyButton={location !== 'shared-bet-card'}
      ref={alertsTooltipRef}
      color={location === 'shared-bet-card' ? 'secondary_outline' : 'secondary_color'}
      disabled={isPending}
      onClick={handleNotifyClick}
    >
      <Icon
        color='primary'
        name={isNotificationsEnabledState ? 'SolidBellRinging01' : 'LineBellPlus'}
      />

      {canShowAlertsTooltip && (
        <Tooltip
          color='blue'
          isHidden={isPending}
          shouldHideCrossIcon
          triggerElRef={alertsTooltipRef}
          hasTooltipBeenSeen={() => false}
          tooltipId='bet-loop-turn-alerts-on'
          onDismissed={() => setShouldShowAlertsTooltip(false)}
          shouldOnlyRenderSingleInstance={true}
          offsetYPx={10}
          offsetXPx={-40}
          flipElement={true}
        >
          <div>Get notified for</div>
          <div>every new bet</div>
        </Tooltip>
      )}
    </Button>
  ) : null
}
